import { LoanStatus, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { Milestone } from '@/components/modules/Funnel/types/Milestone';
import { Step } from '@/components/modules/Funnel/types/Step';

export const StepsDefinitionsAll = [
  {
    statuses: [LoanStatus.STATUS_INITIAL],
    tId: Milestone.INITIAL,
    associatedMilestone: Milestone.INITIAL,
  },
  {
    statuses: [LoanStatusExternal.REQUESTED], // used to merge criteria
    tId: Milestone.REQUESTED,
    associatedMilestone: Milestone.REQUESTED,
  },
  {
    statuses: [LoanStatusExternal.APPROVED], // used to merge criteria
    tId: Milestone.APPROVED,
    associatedMilestone: Milestone.APPROVED,
  },
  {
    statuses: [LoanStatus.STATUS_DOCS_APPROVED],
    tId: Milestone.CONFIRMED,
    associatedMilestone: Milestone.CONFIRMED,
  },
] as Step[];
